var map = {
	"./appinstall-de-2x.avif": 63507,
	"./appinstall-en-2x.avif": 23842,
	"./appinstall-en-USA-2x.avif": 36124,
	"./appinstall-es-2x.avif": 88413,
	"./appinstall-fr-2x.avif": 93910
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 44148;